/* @flow */

import type { NETGEM_API_CHANNEL } from '../../../libs/netgemLibrary/v8/types/Channel';

import { ItemType, type NETGEM_API_V8_FEED_ITEM, type NETGEM_API_V8_ITEM_LOCATION } from '../../../libs/netgemLibrary/v8/types/FeedItem';

const DEFAULT_SCORE = 100;

const createItemFromChannel: (channel: NETGEM_API_CHANNEL) => NETGEM_API_V8_FEED_ITEM | null = (channel) => {
  const { epgid: channelId, isHidden } = channel;

  if (isHidden) {
    return null;
  }

  const selectedLocation: NETGEM_API_V8_ITEM_LOCATION = {
    channelId,
    duration: '',
    id: channelId,
    score: [DEFAULT_SCORE],
    startDate: '',
  };

  return {
    endTime: NaN,
    id: channelId,
    locations: [selectedLocation],
    locType: null,
    score: [DEFAULT_SCORE],
    selectedLocation,
    selectedProgramId: channelId,
    seriesId: null,
    startTime: NaN,
    type: ItemType.Channel,
  };
};

export { createItemFromChannel };
